import { Action } from '@ngrx/store';
import { CpUserActionTypes } from './user.actions';
import { CpTeamUser, CpUserListFilters, CpUserState, initialCpUserState } from './user.model';

export function cpUserReducer(
  state: CpUserState = initialCpUserState,
  action: Action,
): CpUserState {
  const typedAction = action as Action & { payload?: unknown };

  switch (action.type) {
    case CpUserActionTypes.loadUsers:
      return { ...state, loading: true, error: null };
    case CpUserActionTypes.loadUsersSuccess:
      return {
        ...state,
        loading: false,
        users: typedAction.payload as CpTeamUser[],
        lastLoadedAt: Date.now(),
      };
    case CpUserActionTypes.loadUsersFailure:
      return {
        ...state,
        loading: false,
        error: typedAction.payload as string,
      };
    case CpUserActionTypes.setFilters:
      return {
        ...state,
        filters: { ...state.filters, ...(typedAction.payload as Partial<CpUserListFilters>) },
      };
    case CpUserActionTypes.inviteUserSuccess:
      return {
        ...state,
        users: [...state.users, typedAction.payload as CpTeamUser],
      };
    case CpUserActionTypes.updateUserSuccess: {
      const updated = typedAction.payload as CpTeamUser;
      return {
        ...state,
        users: state.users.map(user => (user.id === updated.id ? updated : user)),
      };
    }
    case CpUserActionTypes.removeUserSuccess:
      return {
        ...state,
        users: state.users.filter(user => user.id !== (typedAction.payload as string)),
      };
    default:
      return state;
  }
}
